import React from "react"

import './style.scss'

export default function Banner() {
  return <div className='page-ban'>
    <div className="ban-box">
      <div className="ban-con">
        <div>
          Workshop on Adversarial Machine<br />Learning and Beyond
        </div>
        <p>Workshop at AAAI 2022</p>
        <p>February 28th, 2022</p>
      </div>
    </div>
  </div>
}
